import React from 'react';
import { createRoot } from 'react-dom/client';
import smoothscroll from 'smoothscroll-polyfill';
import { ToastContainer } from 'react-toastify';

// Vendor CSS
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './scss/app.scss';
import 'react-loading-skeleton/dist/skeleton.css';

// Polyfills
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'core-js/stable';
import "indexeddb-getall-shim";

import App from './containers/App';
import withAnalytics from './containers/App/Analytics';
import { installApiRequestMonitor, isLocalhostEnvironment } from './dev/apiRequestMonitor';

smoothscroll.polyfill();

if (isLocalhostEnvironment()) {
    installApiRequestMonitor();
}

const container = document.getElementById('root');
if (container) {
    const root = createRoot(container);
    const TrackedApp = withAnalytics(App);
    root.render(
        <>
            <ToastContainer
                containerId="app-global-toast"
                style={{ zIndex: 10000000 }}
                autoClose={5000}
                position="top-right"
                hideProgressBar
            />
            <TrackedApp />
        </>
    );
}
